import React, { useState } from "react";
import "./ContactUs.css";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    companyName: "",
    email: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value,
    }));
  };

  const validateForm = () => {
    let errors = {};
    if (!formData.name.trim()) errors.name = "Name is required";
    if (!formData.companyName.trim())
      errors.companyName = "Company Name is required";
    if (!formData.email.trim()) {
      errors.email = "Company Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = "Invalid email format";
    }
    if (!formData.message.trim()) errors.message = "Message is required";

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    if (!validateForm()) {
      setIsSubmitting(false);
      return;
    }

    try {
      const form = new FormData();
      form.append("name", formData.name);
      form.append("companyName", formData.companyName);
      form.append("email", formData.email);
      form.append("message", formData.message);

      await fetch(
        "https://script.google.com/macros/s/AKfycbzfs-rlUkoGNBQ7ULn6c_v2F5lfSBLj3hgiq-3XcFP2Epsqgr0HcB_4j24RGWY9BuPc/exec",
        {
          method: "POST",
          body: form,
          mode: "no-cors",
        }
      );

      setSubmitStatus("success");
      setFormData({ name: "", companyName: "", email: "", message: "" });
    } catch (error) {
      console.error("Error:", error);
      setSubmitStatus("error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="modern-contact-container">
      <div className="contact-wrapper">
        <div className="contact-header">
          <h1>Let's Connect</h1>
          <p>Get in touch with us for your engineering design needs</p>
        </div>

        <div className="contact-grid">
          <div className="contact-form-section">
            <form onSubmit={handleSubmit} className="modern-form">
              <div className="form-row">
                <div className="input-group">
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Your Name"
                    className={errors.name ? "error" : ""}
                  />
                  {errors.name && (
                    <small className="error-text">{errors.name}</small>
                  )}
                </div>

                <div className="input-group">
                  <input
                    type="text"
                    id="companyName"
                    name="companyName"
                    value={formData.companyName}
                    onChange={handleChange}
                    placeholder="Company Name"
                    className={errors.companyName ? "error" : ""}
                  />
                  {errors.companyName && (
                    <small className="error-text">{errors.companyName}</small>
                  )}
                </div>
              </div>

              <div className="input-group">
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Email Address"
                  className={errors.email ? "error" : ""}
                />
                {errors.email && (
                  <small className="error-text">{errors.email}</small>
                )}
              </div>

              <div className="input-group">
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Your Message"
                  rows="4"
                  className={errors.message ? "error" : ""}
                />
                {errors.message && (
                  <small className="error-text">{errors.message}</small>
                )}
              </div>

              <button
                type="submit"
                className="submit-button"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Sending..." : "Send Message"}
              </button>

              {submitStatus === "success" && (
                <div className="success-alert">
                  Message sent successfully! 
                </div>
              )}
              {submitStatus === "error" && (
                <div className="error-alert">
                  Failed to send message. Please try again.
                </div>
              )}
            </form>
          </div>

          <div className="contact-info-section">
            <div className="info-card">
              <div className="info-item">
                <div className="icon"></div>
                <div className="details">
                  <h3>Email Us</h3>
                  <p>malek@naew.in</p>
                  <p>info@naew.in</p>
                </div>
              </div>

              <div className="info-item">
                <div className="icon"></div>
                <div className="details">
                  <h3>Call Us</h3>
                  <p>+91-9903376957</p>
                </div>
              </div>

              <div className="info-item">
                <div className="icon"></div>
                <div className="details">
                  <h3>Visit Us</h3>
                  <p>
                    Hooghly
                    <br />
                    Kolkata
                    <br />
                    West Bengal
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
